<template>
  <div>

    <main class="home">
      <div class="content">

        <div class="form">
          <div class="field">
            <label for="email">Email</label>
            <input v-validate="'required'" v-model="auth.username" type="email" name="email" id="email" placeholder="Your email address">
            <span>{{ errors.first('email') }}</span>
          </div>
          <div class="field">
            <label for="password">Password</label>
            <input v-validate="'required'" v-model="auth.password" type="password" name="password" id="password" placeholder="Your password">
            <span>{{ errors.first('name') }}</span>
          </div>
          <div class="field">
            <button class="button" @click="login">Login</button>
          </div>
          <div class="fields-wrap">
            <div class="field">
              <router-link to="/register" class="button grey">Register</router-link>
            </div>
            <div class="field">
              <router-link to="/forgot" class="button grey">Forgot Password</router-link>
            </div>
          </div>
          <p class="http-error" v-if="error" >
            <i v-for="(err, index) in error" :key="index">{{ err }}</i>
          </p>
        </div>

      </div>

      <div class="fixed-popup" :class="{ active: isActive }">
        <div class="alert">
          <p>For best results <strong>visit us via your mobile phone.</strong> <br/></p>
          <div class="change-wrapper">
            <button class="button grey" @click="closePopup">CLOSE</button>
          </div>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'

export default {
  name: 'login',
  components: {
    Logo
  },
  data () {
    return {
      auth: {
        grant_type: 'password',
        client_id: 2,
        client_secret: 'dywb2hhMgxpFcdCVhXHgOGsRWhdFzfTcDiHpLZl0',
        username: null,
        password: null
      },
      error: null,
      isActive: false
    }
  },
  mounted () {
    this.$store.state.isLoading = false
    if (this.$store.state.logged_in) {
      this.$router.push({ path: 'home' })
    }

    if (!this.$store.state.mobileDevice) {
      this.isActive = true
    }
  },
  methods: {
    login () {
      this.$store.state.isLoading = true
      this.$http.login(this.auth)
        .then((res) => {
          console.log('then login', res)
          if (res.status !== undefined) {
            console.log('logged-in')
            this.$router.push({ path: 'home' })
          } else {
            this.error = res.response.data.message
          }
        })
        .then((res) => {
          this.$store.state.isLoading = false
        })
    },
    closePopup () {
      this.isActive = false
    }
  }
}
</script>

<style scoped lang="scss">
@import "../scss/variables.scss";
  body {
    background-color: #F0F0F0;
  }
  main.home {
    padding: 60px 0 105px;

    .form {
      padding: 0 6%;
    }
  }

  .fixed-popup {

    .alert {
      max-width: 350px;
      text-align: center;
    }
  }
</style>
